module.exports = __webpack_public_path__ + "./docs/img/icon-member.9eb86009861d0ed80a3c9ad9695a8f56.svg";